import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import { Button, Grid, Typography } from "@mui/material";

import { useAxios } from "../../../hooks";
import { alert } from "../../../redux/slices/alertSlice";
import FilterDataDialog from "./segment components/FilterDailog";
import { Autocomplete, ComponentHeader, Paper } from "../../../components";

export function SegmentDetails({ formikProps }) {
  const axios = useAxios();
  const dispatch = useDispatch();

  const [filter, setFilter] = useState(false);
  const [segments, setSegments] = useState([]);
  const [newSegment, setNewSegment] = useState();
  const { activeBot } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    axios({
      url: "/reminders/segments/" + activeBot.ID,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setSegments(response.data);
      }
    });
  }, [axios, activeBot.ID, newSegment]);

  return (
    <Fragment>
      <Paper>
        <Grid item xs={12}>
          <ComponentHeader
            title={"Segment Details"}
            subtitle={"Enter details for creating broadcast"}
            buttons={[
              formikProps.values.stagesCount === 1 && (
                <Button variant="outlined" onClick={handleSegment}>
                  Attach Segment
                </Button>
              ),
            ]}
          />
        </Grid>

        <Grid item xs={6}>
          <Autocomplete
            name="segmentID"
            label="Select Segment"
            defaults={{
              primaryKey: "_id",
              displayLabel: "segment_name",
            }}
            options={segments}
            onChange={(_, value, type) => handleChangeSegment(value, type)}
            formikProps={formikProps}
            disableField={formikProps.values.stagesCount >= 2}
          />
          {!Boolean(formikProps.values.stagesCount >= 2) && (
            <Typography>Not able to find your desired segment?</Typography>
          )}
          <Button
            variant="outlined"
            onClick={() => setFilter(true)}
            style={{ marginTop: "2px" }}
          >
            {formikProps.values.stagesCount >= 2 ? (
              <Fragment> Show Segment</Fragment>
            ) : (
              <Fragment> Create Segment</Fragment>
            )}
          </Button>
        </Grid>
      </Paper>

      <FilterDataDialog
        setNewSegment={setNewSegment}
        setFilter={setFilter}
        filter={filter}
        formikProps={formikProps}
        disable={formikProps.values.stagesCount >= 2}
      />
    </Fragment>
  );

  function handleSegment() {
    axios({
      url: "/reminders/segments/attach/" + activeBot.ID,
      method: "PUT",
      data: {
        segment_id: formikProps.values.segmentID,
        broadcast_id: formikProps.values.broadcastID,
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          broadcastID: response.data.broadcast_id,
          segmentID: response.data.segment_id,
          stagesCount: 2,
        }));
        dispatch(
          alert({
            type: "success",
            message: response.message.displayMessage,
          })
        );
      }
    });
  }

  function handleChangeSegment(value, type) {
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        segmentID: value._id,
      }));
    } else {
      value = {
        _id: "",
        intent: "",
      };

      formikProps.setValues((prevVal) => ({
        ...prevVal,
        segmentID: value._id,
      }));
    }
  }
}
